import React, {Component} from 'react';
import LEX from '@homeaway/react-lex';

class BirdhouseComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serviceUrl: this.props.serviceUrl
        };
        this.componentDidMount = this.componentDidMount.bind(this);
        this.redirectPostLogin = this.redirectPostLogin.bind(this);
    }

    componentDidMount() {
    }

    redirectPostLogin() {
        if (typeof window !== 'undefined') {
            let url;
            if (this.props.landingPage === 'success') {
                url = this.state.serviceUrl;
            } else {
                url = `/auth/traveler/login?service=${encodeURIComponent(this.state.serviceUrl)}&site=${this.props.site}${this.props.ticket === '' ? '&authui=false' : ''}`;
            }
            window.location.href = url;
        }
    }

    render() {
        // Check to see if we are being server side rendered
        let service = (typeof window !== 'undefined') ? window.location.href : '';
        return (
            <div className="BirdhouseComponent">
                <LEX
                    service={service}
                    locale={this.props.site.locale}
                    site={this.props.site.siteName}
                    siteName={this.props.site.siteReadableName}
                    handleLoginSuccess={this.redirectPostLogin}
                    serverConfigRendering
                    ticketId={this.props.ticket}
                    landingPage={this.props.landingPage}
                    theme={this.props.site.theme}
                    isLegacy={this.props.isLegacy}
                />
            </div>
        );
    }
}

export default BirdhouseComponent;
